// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var TicketAutoAssignment$ReactHooksTemplate = require("./ticketAutoAssignment.res.js");
var ConfigurationSettingCard$ReactHooksTemplate = require("../common/ConfigurationSettingCard.res.js");

function TicketAutoAssignments(props) {
  var __compact = props.compact;
  var __enforceable = props.enforceable;
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var enforceable = __enforceable !== undefined ? __enforceable : true;
  var compact = __compact !== undefined ? __compact : false;
  var value = TicketAutoAssignment$ReactHooksTemplate.value(setting);
  var toggleValue = function (param) {
    Curry._2(onChange, {
          TAG: "TicketAutoAssignment",
          _0: TicketAutoAssignment$ReactHooksTemplate.setValue(setting, !value)
        }, enforce);
  };
  if (compact) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("h3", {
                                                children: "Ticket Auto Assignment",
                                                className: ConfigurationSettingCard$ReactHooksTemplate.titleClass(value)
                                              }),
                                          JsxRuntime.jsx(ConfigurationSettingCard$ReactHooksTemplate.statusBadge, {
                                                enabled: value
                                              })
                                        ],
                                        className: "flex items-center gap-2 flex-wrap"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: "Instantly routes every ticket to the right owner—no manual effort needed.",
                                        className: ConfigurationSettingCard$ReactHooksTemplate.descriptionClass(value)
                                      })
                                ],
                                className: "min-w-0"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                      checked: value,
                                      disabled: enforced,
                                      handleChange: (function (param) {
                                          if (enforced) {
                                            return ;
                                          } else {
                                            return toggleValue();
                                          }
                                        }),
                                      labelClassName: "flex items-center"
                                    }),
                                className: "flex-shrink-0"
                              })
                        ],
                        className: "flex items-start justify-between gap-3"
                      }),
                  enforceable ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                checked: enforce,
                                disabled: enforced,
                                label: "Enforce Policy",
                                handleChange: (function (param) {
                                    if (!enforced) {
                                      return Curry._2(onChange, {
                                                  TAG: "TicketAutoAssignment",
                                                  _0: setting
                                                }, !enforce);
                                    }
                                    
                                  }),
                                checkboxClassName: "custom_checkbox",
                                labelClassName: "text-xs font-medium text-darkcharcoal"
                              }),
                          className: "mt-3 pt-3 border-t border-gray-200"
                        }) : null,
                  enforced ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "🔒"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: "Enforced by administrator"
                                })
                          ],
                          className: "mt-3 flex items-center gap-1.5 text-xs text-aurometalsaurus"
                        }) : null
                ],
                className: ConfigurationSettingCard$ReactHooksTemplate.compactCardClass(enforced, value)
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "🎯",
                                        className: "text-lg"
                                      }),
                                  JsxRuntime.jsx("h2", {
                                        children: "Ticket Auto Assignment",
                                        className: "text-base font-semibold text-gray-900"
                                      }),
                                  enforced ? JsxRuntime.jsx("span", {
                                          children: "Enforced",
                                          className: "text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded-full"
                                        }) : null
                                ],
                                className: "flex items-center flex-wrap gap-2"
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Instantly routes every ticket to the right owner—no manual effort needed.",
                                className: "text-sm text-gray-600 mt-1"
                              })
                        ],
                        className: "bg-gradient-to-r from-blue-50 to-sky-50 px-5 py-4 border-b border-gray-100"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                checked: value,
                                                disabled: enforced,
                                                handleChange: (function (param) {
                                                    if (enforced) {
                                                      return ;
                                                    } else {
                                                      return toggleValue();
                                                    }
                                                  }),
                                                labelClassName: "flex items-center flex-shrink-0"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "Enable Auto Assignement",
                                                        className: "text-sm font-medium text-gray-800"
                                                      }),
                                                  value ? JsxRuntime.jsx("span", {
                                                          children: "Active",
                                                          className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                                        }) : JsxRuntime.jsx("span", {
                                                          children: "Disabled",
                                                          className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                                        })
                                                ],
                                                className: "flex items-center flex-wrap gap-2 min-w-0"
                                              })
                                        ],
                                        className: "flex items-center gap-3 flex-1 min-w-0"
                                      }),
                                  enforceable ? JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                checked: enforce,
                                                disabled: enforced,
                                                label: "Enforce Policy",
                                                handleChange: (function (param) {
                                                    if (!enforced) {
                                                      return Curry._2(onChange, {
                                                                  TAG: "TicketAutoAssignment",
                                                                  _0: setting
                                                                }, !enforce);
                                                    }
                                                    
                                                  }),
                                                checkboxClassName: "custom_checkbox",
                                                labelClassName: "text-sm font-medium text-gray-700 whitespace-nowrap"
                                              }),
                                          className: "flex items-center space-x-2 px-4 py-2.5 rounded-lg flex-shrink-0 " + (
                                            enforce ? "bg-blue-50 border border-blue-200" : "bg-gray-50 border border-gray-200"
                                          )
                                        }) : null
                                ],
                                className: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
                              }),
                          enforced ? JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "⚠️",
                                                className: "text-sm flex-shrink-0"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "This setting is enforced and cannot be modified",
                                                className: "text-xs font-medium text-amber-900"
                                              })
                                        ],
                                        className: "flex items-start space-x-2"
                                      }),
                                  className: "mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg"
                                }) : null
                        ],
                        className: "p-5"
                      })
                ]
              });
  }
}

var make = TicketAutoAssignments;

exports.make = make;
/* react/jsx-runtime Not a pure module */
